import React, {PropsWithChildren} from 'react';
import {GoogleOAuthProvider} from "@react-oauth/google";
import {AuthStateContextProvider} from "../launcher/auth/LauncherAuthContext";
import {RpgLauncherHeader} from "../launcher/layout/RpgLauncherHeader";

export const CommonEventReservationsLayout: React.FC<PropsWithChildren> = (props) => {
    return (
        <GoogleOAuthProvider clientId="148212513109-3njubdo65cruf3vu8iffkrgngr6pelsf.apps.googleusercontent.com">
            <AuthStateContextProvider>
                <div className="space-align-block" style={{
                    top: 0,
                    width: '100%',
                    height: '90px',
                    zIndex: 9999998,
                    position: 'fixed',
                    backgroundColor: 'white'
                }}>
                    <RpgLauncherHeader />
                </div>

                <div style={{
                    minHeight: 'calc(100vh - 90px)',
                    backgroundColor: '#edede9'
                }}>
                    <div style={{marginTop: '90px', overflowY: 'scroll', padding: '0.5em'}}>
                    {props.children}
                    </div>
                </div>
            </AuthStateContextProvider>
        </GoogleOAuthProvider>
    )
}